import { toast } from "react-toastify";
import { HTTPURL } from "../constants/Matcher";

// list levels for a subject
export async function levels_by_subject(subject_id) {
  try {
    const response = await fetch(
      HTTPURL + `api/levels?subject_id=${subject_id}`
    );
    const responseData = await response.json();
    if (!responseData.status) toast.error(responseData?.message);
    return responseData;
  } catch (error) {
    console.log(error.message);
    return { status: false, message: error.message, data: [] };
  }
}

// add a level
export async function level_add(payload) {
  try {
    const response = await fetch(HTTPURL + "api/level-add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const responseData = await response.json();
    if (responseData.status) toast.success(responseData?.message);
    else toast.error(responseData?.message);
    return responseData;
  } catch (error) {
    console.log(error.message);
    return { status: false, message: error.message };
  }
}

// update a level
export async function level_update(id, payload) {
  try {
    const response = await fetch(HTTPURL + `api/level-update?id=${id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const responseData = await response.json();
    if (responseData.status) toast.success(responseData?.message);
    else toast.error(responseData?.message);
    return responseData;
  } catch (error) {
    console.log(error.message);
    return { status: false, message: error.message };
  }
}

// delete a level
export async function level_destroy(id) {
  try {
    const response = await fetch(HTTPURL + `api/level-destroy?id=${id}`, {
      method: "POST",
    });
    const responseData = await response.json();
    if (responseData.status) toast.success(responseData?.message);
    else toast.error(responseData?.message);
    return responseData;
  } catch (error) {
    console.log(error.message);
    return { status: false, message: error.message };
  }
}
